import { isEmpty } from 'lodash'
import React, { ReactElement } from 'react'
import styled from 'styled-components'

import Field, {
  Label,
  required,
} from '../../../../../../../1stlog-ui/src/components/Field'
import useFieldValue from '../../../../../../../1stlog-ui/src/components/Field/useFieldValue'
import Input from '../../../../../../../1stlog-ui/src/components/Input'
import { useProductSettings } from '../../../../Products'

type TReferenceProps = {
  readonly?: boolean
}

const Reference = (props: TReferenceProps): ReactElement => {
  const { readonly } = props

  const { isColiReferenceTextHidden, isColiReferenceTextMandantory } =
    useProductSettings()

  const coliReferenceText = useFieldValue<string>('coliReferenceText')

  if (isColiReferenceTextHidden) {
    return <></>
  }

  return (
    <>
      {readonly && !isEmpty(coliReferenceText) && (
        <div className="text-center">
          <Label>{i18n.t('reference_text', 'Referenztext')}</Label>
          <h5 className="mt-1">{coliReferenceText}</h5>
        </div>
      )}
      <div hidden={readonly}>
        <Field
          key={String(isColiReferenceTextMandantory)}
          name="coliReferenceText"
          label={i18n.t('reference_text', 'Referenztext')}
          required={isColiReferenceTextMandantory}
          validate={isColiReferenceTextMandantory ? required : undefined}
        >
          <Input
            type="text"
            // astyle={{ width: '100px' }}
          />
        </Field>
      </div>
    </>
  )
}

export default Reference
